import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";
import { Badge } from "@/components/ui/badge";
import { Progress } from "@/components/ui/progress";
import WorkflowPipeline from "./WorkflowPipeline";
import { workflows } from "./workflow-data";

const scoringThresholds = [
  { label: "Shortlist", min: 75, color: "bg-emerald-500", textColor: "text-emerald-700 dark:text-emerald-400" },
  { label: "Consider", min: 60, color: "bg-amber-500", textColor: "text-amber-700 dark:text-amber-400" },
  { label: "Reject", min: 0, color: "bg-red-500", textColor: "text-red-700 dark:text-red-400" },
];

export default function BusinessLogicTab() {
  return (
    <div className="space-y-6">
      <Accordion type="multiple" defaultValue={["cv-pipeline"]}>
        {workflows.map((wf) => (
          <AccordionItem key={wf.id} value={wf.id}>
            <AccordionTrigger className="hover:no-underline">
              <div className="flex items-center gap-3 text-left">
                <span className="font-semibold">{wf.title}</span>
                <Badge variant="secondary" className="text-xs">
                  {wf.steps.length} etapes
                </Badge>
              </div>
            </AccordionTrigger>
            <AccordionContent>
              <div className="space-y-3 pt-2">
                <p className="text-sm text-muted-foreground">
                  {wf.description}
                </p>
                <WorkflowPipeline steps={wf.steps} />
              </div>
            </AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>

      {/* Scoring thresholds visualization */}
      <div className="space-y-4 border rounded-lg p-4">
        <h3 className="text-sm font-semibold">Seuils de decision</h3>
        <div className="space-y-3">
          {scoringThresholds.map((threshold) => (
            <div key={threshold.label} className="space-y-1">
              <div className="flex items-center justify-between text-sm">
                <span className={`font-medium ${threshold.textColor}`}>
                  {threshold.label}
                </span>
                <span className="text-xs text-muted-foreground">
                  {threshold.min > 0 ? `>= ${threshold.min}%` : `< 60%`}
                </span>
              </div>
              <Progress
                value={threshold.min > 0 ? threshold.min : 40}
                className="h-2"
                indicatorClassName={threshold.color}
              />
            </div>
          ))}
        </div>
        <div className="text-xs text-muted-foreground space-y-1 border-t pt-3">
          <p>
            <span className="font-medium">Garde-fou IA</span> : cap a 55 points
            si le modele ne fournit pas de justification concrete (evidence).
          </p>
          <p>
            <span className="font-medium">Mode dual</span> : consensus entre
            Gemini et Infomaniak. Les ecarts significatifs sont signales.
          </p>
        </div>
      </div>
    </div>
  );
}
